import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '@components/base/header.component';
import { AppsStarterComponent } from '@components/header/apps-starter/apps-starter.component';
import { IconComponent } from '@components/icon/icon.component';
import { ImageComponent } from '@components/image/image.component';
import { isApplePlatform } from '@shared/utils/platform.util';
@Component({
  selector: 'app-desktop-header',
  imports: [AppsStarterComponent, CommonModule, ImageComponent, RouterModule, IconComponent],
  templateUrl: './desktop-header.component.html',
  styleUrls: ['./desktop-header.component.scss']
})
export class DesktopHeaderComponent extends HeaderComponent {
  public isProductsDropdownOpen = signal(false);
  public isUserDropdownOpen = signal(false);
  public readonly shortcutKeyLabel = isApplePlatform() ? '⌘K' : 'Strg+K';
  public readonly searchTriggerAriaLabel = `Suchen (${this.shortcutKeyLabel})`;

  public toggleProductsDropdown(): void {
    this.isProductsDropdownOpen.update(current => !current);
    // Close user dropdown when opening products dropdown
    if (this.isProductsDropdownOpen()) {
      this.isUserDropdownOpen.set(false);
    }
  }

  public toggleUserDropdown(): void {
    this.isUserDropdownOpen.update(current => !current);
    // Close products dropdown when opening user dropdown
    if (this.isUserDropdownOpen()) {
      this.isProductsDropdownOpen.set(false);
    }
  }

  public override closeDropdowns(): void {
    this.isProductsDropdownOpen.set(false);
    this.isUserDropdownOpen.set(false);
  }

  public onDropdownItemClick(url: string, event: Event): void {
    event.preventDefault();
    // The dropdowns will be closed before router navigation
    this.closeDropdowns();
    setTimeout(() => {
      // Navigation is delayed by 50 ms
      this.router.navigateByUrl(url);
    }, 50);
  }
}
